import { IChannelConfigList, IUpdateChannelConfig } from '../../../types/air-splitting/products/paymentChannels';
import { EPaymentChannel, IPaymentChannel } from '../../../types/common';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 分账产品 - 支付通道状态修改
 */
export async function updatePayChannelStatus(channelId: EPaymentChannel, enabled: boolean) {
  let data = [] as IPaymentChannel[];
  const action = enabled ? 'enable' : 'disable';

  try {
    const { code, context, message } = await Http.post<any[]>(`${hostUrl}/disburse/channel/${action}/${channelId}`, {});

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账产品 - 支付通道费率修改
 */
export async function updatePayChannelFee(type: EPaymentChannel, fee: string) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/disburse/channel/update`, {
      rate: Number(fee),
      id: type,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/** 获取分账产品-支付通道 编辑费率 详情*/
export async function queryPayChannelsDetail(channelId: number) {
  let data: IChannelConfigList[] = [];

  try {
    const { code, context, message } = await Http.get<IChannelConfigList[]>(`${hostUrl}/disburse/channel-usage/config-list`, { channelId });

    if (code === EAxiosResponseCode.Succeed) {
      let res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/** 获取分账产品-支付通道 编辑费率 编辑*/
export async function updatePayChannelsDetail(params: IUpdateChannelConfig) {

  try {
    const { code, message } = await Http.post<IUpdateChannelConfig>(`${hostUrl}/disburse/channel-usage/modify`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
